import * as S from "./MainTemplate.style";
import { useEffect, useRef } from "react";
// import { Header } from "../../organisms/Header";
import { readAccessToken } from "src/common/functions/authFunctions";
import { Navigate, useLocation } from "react-router-dom";
// import useMenuData from "src/common/hooks/useMenuData";
// import { Footer } from "src/components/organisms/Footer";

interface MainTemplateProps {
  children: React.ReactElement;
}

export const MainTemplate = ({ children }: MainTemplateProps) => {
  const accessToken = readAccessToken();
  // useMenuData();

  const { pathname } = useLocation(); // 라우트 변화 감지
  const contentRef = useRef<HTMLDivElement>(null);
  // const [asideOpen, setAsideOpen] = useState(false);
  // const [innerWidth, setInnerWidth] = useState(window.innerWidth);

  // const { handleContextMenu } = useContextMenu();

  // const resizeListener = () => {
  //   setInnerWidth(window.innerWidth);
  // };

  // const popupOutsideClick = (e: any) => {
  //   setAsideOpen(false);
  // };

  // pathname 변경 시 scroll top
  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [pathname]);

  // const handleAsideOpen = () => {
  //   setAsideOpen(!asideOpen);
  // };

  if (!accessToken) {
    return <Navigate to="/auth/login" />;
  }

  return (
    <S.MainTemplate $asideOpen={false}>
      {/* <Header asideToggle={handleAsideOpen} asideOpen={asideOpen} /> */}
      <S.ContentSection ref={contentRef}>
        {children}
        {/* <Footer /> */}
      </S.ContentSection>
    </S.MainTemplate>
  );
};
